import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapLoaderService {

  

  private isLoadedSubject = new BehaviorSubject<boolean>(false);
  isLoaded$ = this.isLoadedSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  load(): void {
    if ((window as any)['google'] && (window as any)['google'].maps) {
      this.isLoadedSubject.next(true);
      return;
    }

    if (document.getElementById('google-maps-api-script')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-api-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&v=weekly`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.ngZone.run(() => {
        this.isLoadedSubject.next(true);
        console.log('Google Maps loaded');
      });
    };

    script.onerror = (err) => {
      console.error('Google Maps failed to load', err);
    };

    document.head.appendChild(script);
  }

}
